// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import constants from "@store/constants";
import { Dispatch } from "redux";

export type BaseUniquePageLink = { url: string | undefined; type?: string; onClick?: PageLinkModel["onClick"] };

const getUniquePageLink = <T extends BaseUniquePageLink>(
    pageLink: T,
    dispatch: Dispatch<any>,
    uniqueIdsByPageType: Dictionary<string>,
) => {
    let link = pageLink;

    if (link.type === constants.pageType.invoiceHistory) {
        const uniqueId = uniqueIdsByPageType[link.type];

        link = {
            ...link,
            url: uniqueId ? `${link.url}?uid=${uniqueId}` : link.url,
            isExternal: true,
            onClick: () => {
                dispatch({
                    type: "Store/Links/SetUniqueIdForPageType",
                    pageType: link.type,
                });
            },
        };
    }

    return link;
};

export default getUniquePageLink;
